import React from "react";

const defaultCaseStudiesData = [
  {
    casestudy: "",
    nameOfTheRegulatory: "",
  },
];

const CaseStudiesTable = ({ caseStudies, setCaseStudies }) => {
  const handleChange = (index, field, value) => {
    const updated = [...caseStudies];
    updated[index][field] = value;
    setCaseStudies(updated);
  };

  const addRow = () => {
    setCaseStudies([
      ...caseStudies,
      { casestudy: "", nameOfTheRegulatory: "" },
    ]);
  };

  const removeRow = () => {
    if (caseStudies.length > 1) {
      const updated = [...caseStudies];
      updated.pop();
      setCaseStudies(updated);
    }
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          overflowX: "auto",
          overflow: "hidden",
          borderRadius: "8px",
          border: "1px solid #000",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            // borderRadius: "8px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
              <th style={tableHeaderStyle}>Case studies</th>
              <th style={tableHeaderStyle}>
                Name of the regulatory/ enforcement agencies/ judicial
                institutions
              </th>
            </tr>
          </thead>
          <tbody>
            {caseStudies.map((row, index) => (
              <tr key={index}>
                <td style={tableCellStyle}>
                  <textarea
                    placeholder="Case studies"
                    value={row.casestudy}
                    onChange={(e) =>
                      handleChange(index, "casestudy", e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <textarea
                    placeholder="Enter name of regulatory/ judicial institutions"
                    value={row.nameOfTheRegulatory}
                    onChange={(e) =>
                      handleChange(index, "nameOfTheRegulatory", e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "12px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default CaseStudiesTable;
